
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 48 48","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.19 14.873V32.4h28.693V14.007L20.253 3.6 5.191 14.873z","fill":"#11AEFA"}}),_c('path',{attrs:{"d":"M28.504 35.167l-.304-9.53c0-.984 15.672 0 16.32 0 .647 0 .452 9.238.452 9.895 0 .517-3.915.63-15.884.216a.605.605 0 01-.584-.58z","fill":"#F9C258"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M26.1 22.8a.3.3 0 01.3-.3h18.3v.6h-2.47v2.819h-.6V23.1H30.934v2.467h-.6V23.1H26.7v22.2h-.6V22.8z","fill":"#fff"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.07 20.709a.3.3 0 01.3-.3h6.276a.3.3 0 01.3.293l.271 11.96-.6.013-.264-11.666h-5.684v11.66h-.6v-11.96zm2.63 5.472v.997h-.6v-.997h.6z","fill":"#001C45"}})])
          )
        }
      }
    